import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  SkriningPengunjungDaftarFilter,
  SkriningPengunjungLaporanFilter,
  SkriningPengunjungOpsi,
  SkriningPengunjungPage,
  SkriningPengunjungPasienDirawat,
  SkriningPengunjungPasienFilter,
  SkriningPengunjungPayload,
  SkriningPengunjungRekap,
  SkriningPengunjungRow
} from "@/types/skriningPengunjung";

const BASE = "/skrining-pengunjung";

interface GalatBerkas {
  response?: { data?: unknown };
}

function tampilkanGalat(err: unknown) {
  ErrorAlert.showErrorAlert(err);
  return Promise.reject(err);
}

async function opsi(): Promise<SkriningPengunjungOpsi> {
  const res = await http.getData(`${BASE}/opsi`).catch(tampilkanGalat);
  return res.data.data;
}

async function pasienDirawat(
  params: SkriningPengunjungPasienFilter
): Promise<SkriningPengunjungPage<SkriningPengunjungPasienDirawat>> {
  const res = await http
    .getDataParam(`${BASE}/pasien-dirawat`, { params })
    .catch(tampilkanGalat);
  return { data: res.data.data, meta: res.data.meta };
}

async function daftar(
  params: SkriningPengunjungDaftarFilter
): Promise<SkriningPengunjungPage<SkriningPengunjungRow>> {
  const res = await http.getDataParam(BASE, { params }).catch(tampilkanGalat);
  return { data: res.data.data, meta: res.data.meta };
}

async function detail(id: number): Promise<SkriningPengunjungRow> {
  const res = await http.getData(`${BASE}/${id}`).catch(tampilkanGalat);
  return res.data.data;
}

async function simpan(
  data: SkriningPengunjungPayload
): Promise<SkriningPengunjungRow> {
  const res = await http.postData(BASE, data).catch(tampilkanGalat);
  return res.data.data;
}

async function ubah(
  id: number,
  data: SkriningPengunjungPayload
): Promise<SkriningPengunjungRow> {
  const res = await http.putData(`${BASE}/${id}`, data).catch(tampilkanGalat);
  return res.data.data;
}

async function hapus(id: number): Promise<void> {
  await http.deleteData(`${BASE}/${id}`).catch(tampilkanGalat);
}

async function rekap(
  params: SkriningPengunjungLaporanFilter
): Promise<SkriningPengunjungRekap> {
  const res = await http
    .getDataParam(`${BASE}/laporan/rekap`, { params })
    .catch(tampilkanGalat);
  return res.data.data;
}

async function dataLaporan(
  params: SkriningPengunjungLaporanFilter
): Promise<SkriningPengunjungPage<SkriningPengunjungRow>> {
  const res = await http
    .getDataParam(`${BASE}/laporan/data`, { params })
    .catch(tampilkanGalat);
  return { data: res.data.data, meta: res.data.meta };
}

async function laporkanGalatBlob(err: GalatBerkas) {
  const isi = err?.response?.data;

  if (err.response && isi instanceof Blob) {
    err.response.data = await isi
      .text()
      .then(teks => JSON.parse(teks))
      .catch(() => isi);
  }

  ErrorAlert.showErrorAlert(err);
}

function sufiksBerkas(params: SkriningPengunjungLaporanFilter): string {
  if (params.mode === "rentang") {
    return [params.tanggal_dari, params.tanggal_sampai]
      .filter(Boolean)
      .join("_");
  }
  return params.periode || "";
}

async function unduhExcel(params: SkriningPengunjungLaporanFilter) {
  const res = await http
    .getDataParam(`${BASE}/laporan/excel`, { params, responseType: "blob" })
    .catch(async err => {
      await laporkanGalatBlob(err);
      return Promise.reject(err);
    });

  const sufiks = sufiksBerkas(params);
  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = sufiks
    ? `skrining-pengunjung-ranap_${sufiks}.xlsx`
    : "skrining-pengunjung-ranap.xlsx";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default {
  opsi,
  pasienDirawat,
  daftar,
  detail,
  simpan,
  ubah,
  hapus,
  rekap,
  dataLaporan,
  unduhExcel
};
